(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[900],{

/***/ 5109:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(5165);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(5632));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(3469));var _react=_interopRequireDefault(__webpack_require__(2983));var ChevronRight=function ChevronRight(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M9 18l6-6-6-6"}))};var _default=ChevronRight;exports.Z=_default;

/***/ }),

/***/ 3852:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/[[...slug]]",
      function () {
        return __webpack_require__(5516);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/next-superjson-plugin@0.4.9_n4425kxx5r4jmllhb73qnfryoi/node_modules/next-superjson-plugin/tools.js
var tools = __webpack_require__(5630);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(7458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(4517);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next-mdx-remote@3.0.8_biqbaboplfbrettd7655fr4n2y/node_modules/next-mdx-remote/dist/index.js
var dist = __webpack_require__(7424);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/layout/site-layout.tsx + 2 modules
var site_layout = __webpack_require__(9293);
// EXTERNAL MODULE: ../../node_modules/.pnpm/framer-motion@7.6.18_biqbaboplfbrettd7655fr4n2y/node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(2468);
// EXTERNAL MODULE: ../../node_modules/.pnpm/framer-motion@7.6.18_biqbaboplfbrettd7655fr4n2y/node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(4606);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@13.0.6_biqbaboplfbrettd7655fr4n2y/node_modules/next/router.js
var next_router = __webpack_require__(64);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(2983);
// EXTERNAL MODULE: ../../packages/ui/src/components/animation/animation.ts
var animation = __webpack_require__(5759);
// EXTERNAL MODULE: ../../packages/ui/src/components/heading/heading.tsx
var heading = __webpack_require__(7648);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/chevronRight.js
var chevronRight = __webpack_require__(5109);
// EXTERNAL MODULE: ../../packages/ui/src/components/link/link.tsx
var link_link = __webpack_require__(8527);
// EXTERNAL MODULE: ../../packages/ui/src/components/list/list.tsx
var list = __webpack_require__(9648);
// EXTERNAL MODULE: ../../packages/ui/src/styles/common.ts
var common = __webpack_require__(1569);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/side-menu/side-menu.tsx + 4 modules
var side_menu = __webpack_require__(5727);
;// CONCATENATED MODULE: ../../packages/ui/src/blocks/side-bar/side-bar.tsx












/**
 * SideBar is used in mobile and desktop views.
 */ function SideBar(param) {
    let { directories , title , className  } = param;
    const hasValidDirectories = directories.length > 0;
    const header = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: title && hasValidDirectories && /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* Heading */.X, {
            as: "h4",
            className: "px-1 pb-4 font-semibold text-gray-1100",
            children: title
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
                className: (0,clsx_m/* default */.Z)("sticky top-16 isolate hidden h-[calc(100vh-4rem)] w-full flex-shrink-0 flex-col items-start border-r border-gray-500 pl-4 text-gray-1200 sm:flex md:w-64", className),
                children: [
                    header,
                    hasValidDirectories && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full overflow-y-auto pr-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Directories, {
                            directories: directories
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
                className: "w-full sm:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(side_menu/* SideMenu */.f, {
                    position: "br",
                    styles: {
                        items: "w-full overflow-y-auto space-y-2 flex-1 pl-6"
                    },
                    fixed: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(side_menu/* SideMenu.Item */.f.Item, {
                            children: header
                        }),
                        directories.map((dir)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(side_menu/* SideMenu.Item */.f.Item, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex w-full flex-col items-stretch",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectoryItem, {
                                        directory: dir
                                    })
                                })
                            }, getId(dir)))
                    ]
                })
            })
        ]
    });
}
function Directories(param) {
    let { directories  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* List */.a, {
        className: "flex-1 space-y-2",
        children: directories.map((dir)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(list/* List.Item */.a.Item, {
                hideMarker: true,
                className: "flex w-full flex-col items-stretch",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectoryItem, {
                    directory: dir
                })
            }, getId(dir)))
    });
}
function DirectoryItem(param) {
    let { directory: dir  } = param;
    const router = (0,next_router.useRouter)();
    const [isOpened, setIsOpened] = react.useState(()=>isButtonActive(dir, router.asPath));
    const listMarker = dir.route ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "mr-3.5 inline-block h-1.5 w-1.5 rounded-full bg-current hover:bg-gray-1200"
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(chevronRight/* default */.Z, {
        size: 18,
        className: (0,clsx_m/* default */.Z)("-ml-1.5 mr-2 transition", isOpened && "rotate-90"),
        onClick: (e)=>{
            e.stopPropagation();
            setIsOpened((prev)=>!prev);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            dir.route ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(link_link/* Link */.r, {
                href: dir.route,
                className: (0,clsx_m/* default */.Z)("capitalize", clickableItemStyle, router.asPath === dir.route && activeStyle),
                hideUnderline: true,
                variant: "secondary",
                children: [
                    listMarker,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: dir.title
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: (0,clsx_m/* default */.Z)("capitalize", clickableItemStyle, isButtonActive(dir, router.asPath) && activeStyle),
                type: "button",
                onClick: ()=>setIsOpened((prev)=>!prev),
                "aria-label": "Expand children routes",
                children: [
                    listMarker,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: dir.title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                children: dir.children && isOpened && /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion_minimal.m.div, {
                    ...animation/* expanded */.zh,
                    className: "flex flex-row items-stretch overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                            className: "ml-0.5 w-3.5 border-l"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Directories, {
                            directories: dir.children
                        })
                    ]
                })
            })
        ]
    });
}
const clickableItemStyle = [
    "flex flex-row items-center justify-start",
    common/* listHoverable */.D6
];
const activeStyle = "bg-primary-500 border border-primary-700 text-primary-1100";
function isButtonActive(dir, pathname) {
    if (dir.route === pathname) {
        return true;
    }
    if (dir.children) {
        for (const child of dir.children){
            if (isButtonActive(child, pathname)) {
                return true;
            }
        }
        return false;
    }
    return false;
}
function getId(dir) {
    return dir.title + (dir.route || "");
}

// EXTERNAL MODULE: ../../packages/ui/src/blocks/mdx-components/mdx-components.tsx
var mdx_components = __webpack_require__(2127);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/footer/footer.tsx
var footer = __webpack_require__(296);
;// CONCATENATED MODULE: ../../packages/ui/src/pages/docs/index.tsx






function Docs(param) {
    let { mdxSource , frontMatter , directories =[] , nearNav  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(site_layout/* default */.Z, {
        title: (frontMatter === null || frontMatter === void 0 ? void 0 : frontMatter.title) || "Docs",
        hideFullBleed: true,
        hideFooter: true,
        styles: {
            container: "py-0 md:mx-0"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex min-h-full flex-col",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "flex min-h-full w-full flex-1 flex-row space-x-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SideBar, {
                        className: "pt-10",
                        directories: directories,
                        title: "Document"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                className: "prose mx-auto overflow-x-hidden pt-10",
                                children: mdxSource && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* MDXRemote */.R, {
                                    ...mdxSource,
                                    components: mdx_components/* MDXComponents */.t
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "mt-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mx-auto flex max-w-[65ch] flex-row justify-between",
                                    children: [
                                        nearNav.prev ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(link_link/* Link */.r, {
                                            size: "lg",
                                            variant: "plain",
                                            href: nearNav.prev.link,
                                            className: (0,clsx_m/* default */.Z)("flex flex-row items-center px-3 py-2 text-gray-1200 sm:-translate-x-5", common/* listHoverable */.D6),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chevronRight/* default */.Z, {
                                                    size: 28,
                                                    className: "rotate-180"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: nearNav.prev.title
                                                })
                                            ]
                                        }) : // To fill left empty when there is only 1 next
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                        nearNav.next && /*#__PURE__*/ (0,jsx_runtime.jsxs)(link_link/* Link */.r, {
                                            size: "lg",
                                            variant: "plain",
                                            href: nearNav.next.link,
                                            className: (0,clsx_m/* default */.Z)("flex flex-row items-center px-3 py-2 text-gray-1200 sm:translate-x-5", common/* listHoverable */.D6),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: nearNav.next.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chevronRight/* default */.Z, {
                                                    size: 28,
                                                    className: ""
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* Footer */.$, {})
                        ]
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/pages/docs/[[...slug]].tsx


var __N_SSG = true;
/* harmony default export */ var _slug_ = ((0,tools.withSuperJSONPage)(Docs));


/***/ }),

/***/ 2127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ MDXComponents; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7458);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4517);
/* harmony import */ var _components_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8527);
/* harmony import */ var _mdx_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6367);
/* harmony import */ var _mdx_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_mdx_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const MDXComponents = {
    a: MDXLink,
    pre: Pre
};
function MDXLink(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_link__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .r, {
        href: props.href || "",
        variant: "primary",
        children: props.children
    });
}
function Pre(param) {
    let { children , className , ...restProps } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("pre", {
        ...restProps,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("not-prose whitespace-normal break-all md:whitespace-pre md:break-words", (_mdx_module_scss__WEBPACK_IMPORTED_MODULE_3___default().blockPre), className),
        children: children
    });
}


/***/ }),

/***/ 9648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ List; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7458);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2983);



const variantTags = {
    ordered: "ol",
    unordered: "ul"
};
function List(param) {
    let { className , variant ="unordered" , ...restProps } = param;
    const Tag = variantTags[variant];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        ...restProps,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex list-none flex-col py-2", className)
    });
}
List.Item = ListItem;
function ListItem(param) {
    let { className , children , styles ={} , hideMarker , ...liProps } = param;
    const ChildrenContainer = typeof children === "string" ? "span" : react__WEBPACK_IMPORTED_MODULE_1__.Fragment;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
        ...liProps,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex flex-row items-center space-x-2 text-gray-1100", className),
        children: [
            !hideMarker && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("h-2 w-2 rounded-full bg-current", styles.marker)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ChildrenContainer, {
                children: children
            })
        ]
    });
}


/***/ }),

/***/ 6367:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blockPre":"mdx_blockPre__qYcGw"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [393,98,322,570,293,774,888,179], function() { return __webpack_exec__(3852); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);